export default __webpack_public_path__ + "static/media/thumbnail.cf7dda4e.png";